/* CX tee upload guard — custom case pages using teeinblue's own photo form.
   teeinblue bug: on a weak signal its crop window opens on the photo without its move / turn
   handles, and they never come, even once the signal is back. While the window has no handles
   a note over it says the photo is still uploading; once the photo has reached teeinblue the
   window is closed (Cancel keeps the photo) and opened again (its Edit button), which brings
   the handles. Checked again every STUCK_RECHECK_MS, up to MAX_REOPENS times per photo. */
(function () {
  'use strict';

  if (window.cxTeeUploadGuard) return;
  window.cxTeeUploadGuard = true;

  var NOTE_TEXT = 'Uploading your photo…';
  // How often the open window is checked, and how long it counts as "still opening" (it is
  // briefly not visible while it fades in and while it's closed and reopened).
  var WATCH_MS = 100;
  var GONE_MS = 1500;
  var OPEN_WAIT_MS = 10000;
  var NOTE_OFFSET = 12;
  // A window without handles after its photo is uploaded is reopened this long after; again
  // every STUCK_RECHECK_MS while still stuck, up to MAX_REOPENS times per photo.
  var STUCK_EDITOR_MS = 800;
  var STUCK_RECHECK_MS = 5000;
  var MAX_REOPENS = 4;
  // After Cancel the window takes a moment to close; then its Edit button is pressed every
  // REOPEN_TRY_MS until it's open again (up to REOPEN_TRIES tries).
  var REOPEN_TRY_MS = 250;
  var REOPEN_TRIES = 16;

  var watch = null;
  var watchFrom = 0;
  var seen = false;
  var closedSince = 0;
  var stuckSince = 0;
  var nextReopenAt = 0;
  var reopening = false;
  var photoSrc = null;
  var reopens = 0;

  function placement() {
    var body = document.querySelector('.vm--modal .tee-image-placement-body');
    return body && body.offsetParent !== null ? body : null;
  }

  function teePhotoImage() {
    return document.querySelector('.tee-field--photo .tee-photo-image');
  }

  // The photo is on teeinblue's server (not still a preview from the device).
  function photoUploaded() {
    var image = teePhotoImage();
    var src = image ? image.getAttribute('src') || '' : '';
    if (!src || src.indexOf('blob:') === 0) return '';
    if (document.querySelector('.tee-field--photo .tee-photo-uploading, .tee-field--photo .tee-loading')) return '';
    return src;
  }

  function windowButton(pattern) {
    return Array.prototype.find.call(document.querySelectorAll('.vm--modal button'), function (button) {
      return pattern.test(button.textContent.trim());
    });
  }

  function editButton() {
    return Array.prototype.find.call(document.querySelectorAll('.tee-btn--recustomize'), function (button) {
      return button.offsetParent !== null;
    }) || document.querySelector('.tee-btn--recustomize');
  }

  function reopen() {
    var cancel = windowButton(/^cancel$/i);
    if (!cancel || !editButton()) return;
    reopening = true;
    reopens += 1;
    cancel.click();
    var tries = 0;
    var pressed = false;
    var timer = setInterval(function () {
      tries += 1;
      var open = !!placement();
      if ((pressed && open) || tries > REOPEN_TRIES) {
        clearInterval(timer);
        reopening = false;
        nextReopenAt = Date.now() + STUCK_RECHECK_MS;
        return;
      }
      if (open) return;
      var edit = editButton();
      if (edit) edit.click();
      pressed = true;
    }, REOPEN_TRY_MS);
  }

  function showNote(body) {
    var note = document.querySelector('[data-cx-tee-guard-note]');
    if (!body) {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('div');
      note.className = 'cx-tee-guard-note';
      note.setAttribute('data-cx-tee-guard-note', '');
      note.setAttribute('role', 'status');
      var spinner = document.createElement('span');
      spinner.className = 'cx-tee-guard-note__spinner';
      spinner.setAttribute('aria-hidden', 'true');
      note.appendChild(spinner);
      note.appendChild(document.createTextNode(NOTE_TEXT));
      document.body.appendChild(note);
    }
    var rect = body.getBoundingClientRect();
    note.style.top = Math.round(rect.top + NOTE_OFFSET) + 'px';
    note.style.left = Math.round(rect.left + rect.width / 2) + 'px';
  }

  function stopWatching() {
    clearInterval(watch);
    watch = null;
    if (!reopening) showNote(null);
  }

  function check() {
    var body = placement();
    var now = Date.now();
    if (!body) {
      if (reopening) return;
      if (!seen) {
        if (now - watchFrom > OPEN_WAIT_MS) stopWatching();
      } else if (!closedSince) {
        closedSince = now;
      } else if (now - closedSince > GONE_MS) {
        stopWatching();
      }
      showNote(null);
      return;
    }
    seen = true;
    closedSince = 0;
    var stuck = !body.querySelector('.tee-draggable');
    showNote(stuck ? body : null);
    if (!stuck) {
      stuckSince = 0;
      return;
    }
    if (!stuckSince) stuckSince = now;
    var uploaded = photoUploaded();
    if (!uploaded || reopening) return;
    if (uploaded !== photoSrc) {
      photoSrc = uploaded;
      reopens = 0;
      nextReopenAt = 0;
    }
    if (reopens < MAX_REOPENS && now - stuckSince >= STUCK_EDITOR_MS && now >= nextReopenAt) reopen();
  }

  function startWatching() {
    watchFrom = Date.now();
    seen = false;
    closedSince = 0;
    if (watch) return;
    watch = setInterval(check, WATCH_MS);
    check();
  }

  // The window opens after a photo is picked or teeinblue's Edit button is pressed.
  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('.tee-field--photo input[type="file"]')) startWatching();
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.tee-btn--recustomize')) startWatching();
  }, true);
})();
